import { GraphQLResult, generateClient } from "aws-amplify/api";
import { Image } from "db/definitions";
import { bulkRetrieveImagesByFormGroup } from "db/queries/imageQueries";
// @ts-ignore
import { getImagesByFormGroup } from "graphql/queries";

/**
 * Given the formGroup id and whether or not the user is online, queries the relevant database for the images with the formGroup id
 * @author Eric Webb <ewebb@factorearth.com>
 * @param id The formGroup's id
 * @param online Whether or not the user is online
 * @returns THe images that are part of the formGroup
 */
export async function batchGetImagesByFormGroup(id: string, online: boolean): Promise<Image[]> {
	const images: Image[] = [];
	if (online) {
		interface QueryResponse {
			imagesByFormGroup: {
				items: Image[] | null;
				nextToken: string | null;
			};
		}
		let nextToken;
		while (nextToken !== null) {
			const client = generateClient({ authMode: "userPool" });
			const result = (await client.graphql({
				query: getImagesByFormGroup,
				authMode: "userPool",
				variables: {
					formGroup: id,
					nextToken,
				},
			})) as GraphQLResult<QueryResponse>;
			if (result.data.imagesByFormGroup.items) {
				for (const image of result.data.imagesByFormGroup.items) {
					images.push(image);
				}
			}
			nextToken = result.data.imagesByFormGroup.nextToken;
		}
	} else {
		const images = await bulkRetrieveImagesByFormGroup(id);
		return images;
	}
	return images;
}
